import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Banner from "./Banner"
import Footer from "./Footer"

import "./layout.css"

import "@fontsource/montserrat"
import "@fontsource/comfortaa"

const Layout = ({ children }) => {
  return (
    <>
      <Banner />
      <main>{children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
